import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { numberFormat, onlyNumber } from '../../../Utils/Common';
import { MiniSpinner } from '../../layouts/Spinner';
import {
    handleInputChange,
    updateQty,
    submitStockTransfer,
    resetModalInputs,
    searchSubmit,
    removeScan,
} from '../../../redux/actions/stock_transfer/stock_transfer.actions';
import { ToastDanger } from '../../../Services/_toast.service';
import ItemModal from './itemModal';

function TransferModal({
    stock_transfer,
    show,
    onHide,
    updateQty,
    submitStockTransfer,
    handleInputChange,
    resetModalInputs,
    searchSubmit,
    removeScan,
}) {
    const [isTransfering, setIsTransfering] = useState(false);
    const [transferType, setTransferType] = useState(null); // 'in' | 'out' | null

    // Reset every time the modal opens
    useEffect(() => {
        if (show) {
            setTransferType(null);
            setIsTransfering(false);
        }
    }, [show]);

    const handleSubmitTransfer = async () => {
        if (!remarks || !remarks.trim()) {
            return ToastDanger('Remarks is required');
        }
        setIsTransfering(true);
        try {
            await submitStockTransfer(transferType);
        } catch (error) {
            console.error('Error processing transfer:', error);
        } finally {
            setIsTransfering(false);
        }
    };

    const { transfer_item, remarks } = stock_transfer;
    const isScanning = stock_transfer.loading === 'transfer-search';

    if (!show) return null;

    return (
        <Modal show={show} onHide={onHide} size="md" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    Process Transfer{' '}
                    {transferType && (
                        <span
                            className={`badge badge-${transferType === 'in' ? 'success' : 'danger'} ml-2`}
                            style={{ fontSize: '0.75rem', verticalAlign: 'middle' }}
                        >
                            {transferType.toUpperCase()}
                        </span>
                    )}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {transferType === null ? (
                    /* ── Transfer Type Selection ── */
                    <div className="text-center py-5">
                        <p
                            className="mb-4"
                            style={{ fontSize: '1.1rem', fontWeight: 600 }}
                        >
                            Choose Transfer Type
                        </p>
                        <div className="d-flex justify-content-center">
                            <button
                                className="btn btn-success btn-lg mr-4"
                                style={{ minWidth: '120px' }}
                                onClick={() => setTransferType('in')}
                            >
                                <i className="ft ft-arrow-down mr-1"></i> IN
                            </button>
                            <button
                                className="btn btn-danger btn-lg"
                                style={{ minWidth: '120px' }}
                                onClick={() => setTransferType('out')}
                            >
                                <i className="ft ft-arrow-up mr-1"></i> OUT
                            </button>
                        </div>
                    </div>
                ) : (
                    /* ── Scan UI ── */
                    <div className="col-12 mb-2 pr-2">
                        <div className="row p-2">
                            <div className="row mb-1">
                                <label className="col-md-4 col-sm-12 pl-0 text-center align-self-center">
                                    SKU/Barcode:{' '}
                                </label>
                                <div className="col-md-7 col-10 px-0">
                                    <form
                                        onSubmit={(e) =>
                                            searchSubmit(e, 'btn', transferType)
                                        }
                                    >
                                        <div className="input-group mb-0">
                                            <input
                                                type="text"
                                                id="search"
                                                value={stock_transfer.search}
                                                onChange={handleInputChange}
                                                name="search"
                                                className="form-control f-regular"
                                                placeholder="Search"
                                                required
                                                disabled={
                                                    isScanning || isTransfering
                                                }
                                            />
                                            <div className="input-group-append">
                                                <button
                                                    className="btn btn-sm btn-primary btn-z-index search-btn"
                                                    type="submit"
                                                    disabled={
                                                        isScanning ||
                                                        isTransfering
                                                    }
                                                >
                                                    {isScanning ? (
                                                        <span
                                                            className="spinner-border spinner-border-sm"
                                                            role="status"
                                                            aria-hidden="true"
                                                        ></span>
                                                    ) : (
                                                        <i className="ft ft-search"></i>
                                                    )}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="col-1 pr-0">
                                    <div className="float-right">
                                        <div className="input-group-prepend">
                                            <span
                                                href="#"
                                                className="tool-tip text-primary"
                                                data-tip="this is a tool tip"
                                            >
                                                <i className="la la-question-circle"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {transfer_item.length > 0 ? (
                                <div className="col-12 card p-1">
                                    <div className="card-header p-0">
                                        <div className="d-flex justify-content-end">
                                            <div>
                                                {isScanning ? (
                                                    ''
                                                ) : (
                                                    <i
                                                        onClick={() =>
                                                            removeScan()
                                                        }
                                                        className="ft ft-x ft-tran-icon font-weight-bold pos-close"
                                                    ></i>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card-body row pt-0">
                                        {isScanning ? (
                                            <div className="mx-auto my-4">
                                                <MiniSpinner />
                                            </div>
                                        ) : (
                                            <div className="row my-2">
                                                <div className="col-lg-12 col-12">
                                                    <div className="row justify-content-between">
                                                        <div className="d-flex justify-content-center">
                                                            <div className="col-6">
                                                                <img
                                                                    src={
                                                                        transfer_item[0]
                                                                            .product_image
                                                                    }
                                                                    className="img-fluid pos-img mt-0 pt-0"
                                                                    alt="img"
                                                                />
                                                            </div>

                                                            <div className="col-6 d-flex justify-content-center align-items-center">
                                                                <div className="input-group-prepend">
                                                                    <span
                                                                        onClick={() =>
                                                                            updateQty(
                                                                                'dec'
                                                                            )
                                                                        }
                                                                        className="input-group-text p-0 pos-btn-grey"
                                                                    >
                                                                        <i className="ft ft-minus pos-qty-icon"></i>
                                                                    </span>
                                                                </div>
                                                                <input
                                                                    onChange={(
                                                                        e
                                                                    ) =>
                                                                        updateQty(
                                                                            'set',
                                                                            e
                                                                                .target
                                                                                .value
                                                                        )
                                                                    }
                                                                    onKeyPress={(
                                                                        e
                                                                    ) =>
                                                                        onlyNumber(
                                                                            e
                                                                        )
                                                                    }
                                                                    name="qty"
                                                                    value={
                                                                        transfer_item[0]
                                                                            .qty
                                                                    }
                                                                    type="number"
                                                                    className="form-control form-control-lg f-regular text-center"
                                                                    min="1"
                                                                />
                                                                <div className="input-group-append">
                                                                    <span
                                                                        onClick={() =>
                                                                            updateQty(
                                                                                'inc'
                                                                            )
                                                                        }
                                                                        className="input-group-text p-0 pos-btn-grey"
                                                                    >
                                                                        <i className="ft ft-plus pos-qty-icon"></i>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-12">
                                                            {transfer_item[0]
                                                                .stockWarning && (
                                                                <span className="lbl-status lbl-lg lbl-pos-warning">
                                                                    LOW THRESHOLD
                                                                </span>
                                                            )}
                                                            <div className="pos-strong-text pt-1">
                                                                {
                                                                    transfer_item[0]
                                                                        .product_name
                                                                }
                                                            </div>
                                                            <div className="pos-description">
                                                                SKU:{' '}
                                                                {
                                                                    transfer_item[0]
                                                                        .sku
                                                                }
                                                            </div>
                                                            <div className="pos-description">
                                                                Barcode:{' '}
                                                                {
                                                                    transfer_item[0]
                                                                        .barcode
                                                                }
                                                            </div>
                                                            <div className="pos-description">
                                                                Brand:{' '}
                                                                {
                                                                    transfer_item[0]
                                                                        .brand_name
                                                                }
                                                            </div>
                                                            <div className="pos-description mb-2">
                                                                SRP: P{' '}
                                                                {numberFormat(
                                                                    transfer_item[0]
                                                                        .srp
                                                                )}
                                                            </div>

                                                            <div>
                                                                <b>Remarks:</b>
                                                                <textarea
                                                                    rows="2"
                                                                    placeholder="Remarks"
                                                                    name="remarks"
                                                                    value={
                                                                        remarks
                                                                    }
                                                                    onChange={
                                                                        handleInputChange
                                                                    }
                                                                    className="form-control f-regular mt-2"
                                                                    required
                                                                ></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ) : (
                                <div className="col-12 card mb-0">
                                    <div className="card-body row pos-blank-card">
                                        {/* THIS IS A EMPTY CARD */}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </Modal.Body>

            <Modal.Footer>
                {transferType !== null && (
                    <button
                        className="btn btn-primary btn-trans"
                        onClick={handleSubmitTransfer}
                        disabled={
                            isTransfering ||
                            isScanning ||
                            transfer_item.length === 0
                        }
                    >
                        {isTransfering && (
                            <span
                                className="spinner-border spinner-border-sm mr-1"
                                role="status"
                                aria-hidden="true"
                            ></span>
                        )}
                        {transferType === 'in'
                            ? 'In Stock Transfer'
                            : 'Out Stock Transfer'}
                    </button>
                )}
            </Modal.Footer>

            {/* ITEM MODAL */}
            <ItemModal transferType={transferType} />
        </Modal>
    );
}

const mapStateToProps = (state) => ({
    stock_transfer: state.stock_transfer,
    show: state.stock_transfer.stock_transfer_modal,
});

export default connect(mapStateToProps, {
    handleInputChange,
    updateQty,
    submitStockTransfer,
    resetModalInputs,
    searchSubmit,
    removeScan,
})(TransferModal);
